import { render, staticRenderFns } from "./bannerDetail.vue?vue&type=template&id=3689ff92&scoped=true"
import script from "./bannerDetail.vue?vue&type=script&lang=js"
export * from "./bannerDetail.vue?vue&type=script&lang=js"
import style0 from "./bannerDetail.vue?vue&type=style&index=0&id=3689ff92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3689ff92",
  null
  
)

export default component.exports